import React from 'react';

import { AvatarIcon } from './styles';

const Avatar = ({ size }) => <AvatarIcon size={size} />;

export default Avatar;
